var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ticket"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 17.2904H5.83335C2.15835 17.2904 1.04169 16.1737 1.04169 12.4987V12.082C1.04169 11.7404 1.32502 11.457 1.66669 11.457C2.46669 11.457 3.12502 10.7987 3.12502 9.9987C3.12502 9.1987 2.46669 8.54036 1.66669 8.54036C1.32502 8.54036 1.04169 8.25703 1.04169 7.91536V7.4987C1.04169 3.8237 2.15835 2.70703 5.83335 2.70703H14.1667C17.8417 2.70703 18.9584 3.8237 18.9584 7.4987V8.33203C18.9584 8.6737 18.675 8.95703 18.3334 8.95703C17.5334 8.95703 16.875 9.61536 16.875 10.4154C16.875 11.2154 17.5334 11.8737 18.3334 11.8737C18.675 11.8737 18.9584 12.157 18.9584 12.4987C18.9584 16.1737 17.8417 17.2904 14.1667 17.2904ZM2.29169 12.632C2.30835 15.4987 2.90002 16.0404 5.83335 16.0404H14.1667C16.95 16.0404 17.625 15.5487 17.7 13.0487C16.5084 12.7654 15.625 11.6904 15.625 10.4154C15.625 9.14036 16.5167 8.06536 17.7084 7.78203V7.4987C17.7084 4.5237 17.15 3.95703 14.1667 3.95703H5.83335C2.90002 3.95703 2.30835 4.4987 2.29169 7.36536C3.48335 7.6487 4.37502 8.7237 4.37502 9.9987C4.37502 11.2737 3.48335 12.3487 2.29169 12.632Z",
    fill: "#026C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33335 6.04036C7.99169 6.04036 7.70835 5.75703 7.70835 5.41536V3.33203C7.70835 2.99036 7.99169 2.70703 8.33335 2.70703C8.67502 2.70703 8.95835 2.99036 8.95835 3.33203V5.41536C8.95835 5.75703 8.67502 6.04036 8.33335 6.04036Z",
    fill: "#026C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33335 12.1487C7.99169 12.1487 7.70835 11.8654 7.70835 11.5237V8.46536C7.70835 8.1237 7.99169 7.84036 8.33335 7.84036C8.67502 7.84036 8.95835 8.1237 8.95835 8.46536V11.5237C8.95835 11.8737 8.67502 12.1487 8.33335 12.1487Z",
    fill: "#026C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33335 17.2904C7.99169 17.2904 7.70835 17.007 7.70835 16.6654V14.582C7.70835 14.2404 7.99169 13.957 8.33335 13.957C8.67502 13.957 8.95835 14.2404 8.95835 14.582V16.6654C8.95835 17.007 8.67502 17.2904 8.33335 17.2904Z",
    fill: "#026C96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.7fa2ff24bc8f36a2f19c0dabd7bc599d.svg";
export { ForwardRef as ReactComponent };